export default __webpack_public_path__ + "static/img/14.abd9e08.png";